import _example from './modules/_example';
import selector from './modules/selector';
import store from './modules/store';
import i18n from './modules/i18n';
var VUE = null;

export default (Vuex, _VUE) => {
  VUE = _VUE;
  return new Vuex.Store({
    state: {
      id: null,
      email: null,
      userName: null,
      headImageUrl: null,
      thirdPartyAccounts: [],
      toLogin: false,
      loginSuccess: false,
      loginNext: null, // 存储login后接下来的步骤{type: 'claim/create', id: ''}
      stores: {}, // 存储用户名下认领的门店
      businessId: null,
      protocols: [{
        name: '《Dealmoon 商家入驻协议》',
        router: '/agreement/admission'
      }, {
        name: '《Dealmoon用户服务协议》',
        router: '/agreement/user'
      }],
      supportEmail: 'localsupport@dealmoon.com',
      businessInfo: { // 当前门店 - 如果available为 false 则证明在审核中或者审核失败
        id: null,
        available: false,
        storeReview: null, // 审核的状态
        data: null, // business 内容
        privileges: [], //权限
        role: '', //角色
        valueAddInfos: [], // 增值服务功能
      },
      abortBusinessId: null, // 放弃认领门店
      privilegesDefault: null,
      wechat: {
        appId: (location.host || '').indexOf('biz.dealmoon') > -1 ? 'wxccef1a7cf452398d' : 'wx67c764a243dea88a'
      }
    },
    mutations: {
      UPDATE_CUR_BUSINESS(state, businessInfo) {
        state.businessId = businessInfo.id;
        for (var i in state.businessInfo) {
          if (typeof businessInfo[i] == 'undefined') {
            businessInfo[i] = state.businessInfo[i]
          }
          if (i == 'privileges' && typeof businessInfo['privileges'] == 'string') {
            businessInfo['privileges'] = VUE.prototype.$utils.parsePrivileges(businessInfo['privileges']);
          }
        }
        state.businessInfo = businessInfo;
      },
      UPDATE_USERINFO(state, userInfo) {
        state.id = userInfo.id;
        state.email = userInfo.email;
        state.userName = userInfo.userName;
        state.businessId = userInfo.businessId;
        // state.bussUserRelList = userInfo.bussUserRelList;
        state.headImageUrl = userInfo.headImageUrl;
        state.thirdPartyAccounts = userInfo.thirdPartyAccounts;
      },
      FORCE_TO_LOGIN(state) {
        state.toLogin = true
      },
      CLOSE_TO_LOGIN(state) {
        state.toLogin = false
      },
      UPDATE_LOGIN_SUCCESS(state) {
        state.loginSuccess = true
      },
      UPDATE_LOGIN_NEXT(state, next) {
        if (next && next.type) {
          state.loginNext = next
        }
      },
      UPDATE_STORES_LIST(state, storeList = []) {
        for (var i in storeList) {
          state.stores[storeList[i].businessId + ''] = storeList[i]
        }
      },
      UPDATE_ABORT_BUSINESS_ID(state, id) {
        state.abortBusinessId = id
      },
      UPDATE_PRIVILEGES_DEFAULT(state, privileges) {
        state.privilegesDefault = privileges;
      }
    },
    getters: {},
    actions: {},
    modules: {
      _example,
      store,
      i18n,
      selector
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js